<template>
  <div class="has-background-white user-permission-tab has-radius-top-left">
    <div class="column">
      <div class="columns is-align-items-center has-background-grey-lighter has-radius-top-left ml-0" v-if="dataLoaded">
        <div class="column is-narrow is-flex is-align-items-center">
          <h3
            class="has-text-weight-bold line-height has-text-black-bis is-size-3"
          >
            Viewing Permissions
          </h3>
          <div class="field mb-0">
            <o-checkbox v-model="viewAll" :disabled="!orderPermissionEdit">
              <span class="has-text-black-bis has-text-weight-bold">
                View all projects' orders ({{ viewAll ? "Enabled" : "Disabled" }})
              </span>
            </o-checkbox>
          </div>
          <div class="field">
            <o-checkbox v-model="resumeAll" :disabled="!orderPermissionEdit">
              <span class="has-text-black-bis has-text-weight-bold"> Resume Orders By Everyone </span>
            </o-checkbox>
          </div>
        </div>
         <div class="is-divider-vertical mx-0"></div>
        <div class="column">
          <p class="buttons">
            <button
              class="button has-text-black-bis"
              v-if="!orderPermissionEdit"
              @click="orderPermissionEdit = true"
              v-tooltip="'Edit'"
              v-permission="{
                permissionModule: 'app&projects',
                type: 'alterPermission',
              }"
            >
              <span class="icon">
                <i class="icon-edit"></i>
              </span>
            </button>
            <button
              class="button p-0 has-text-white is-success"
              v-if="orderPermissionEdit"
              @click="ordersPermissionSave"
              v-tooltip="'Save'"
            >
              <i class="icon-checkmark has-text-white"></i>
            </button>
            <button
              @click="cancelOrederPermissionEdit"
              v-tooltip="'Cancel'"
              v-if="orderPermissionEdit"
              class="button is-outlined is-danger p-0"
            >
              <i class="icon-close has-text-black-bis"></i>
            </button>
          </p>
        </div>
      </div>
      <div class="columns is-multiline" v-if="dataLoaded">
        <div class="column is-4 permission-mftable">
          <div class="has-background-grey-lighter is-border-radius-sm">
          <div class="columns">
            <div class="column is-narrow">
              <button
                class="button px-0 has-text-dark"
                @click="showActivityLog = true"
              >
                <i class="icon-activityhistory"></i>
              </button>
            </div>
            <div class="is-divider-vertical mx-0"></div>
                      <div class="column is-narrow pb-0">
              <button
                :disabled="disableAction"
                class="button has-text-black-bis px-0"
                v-tooltip="'Add New'"
                @click="onCellClicked({ type: 'add' })"
              >
                <i class="icon-addnew"
                ></i>
              </button>
            </div>
            <div class="is-divider-vertical mx-0"></div>
            <div class="column pr-0">
              <search-bar
                :shouldEmit="true"
                @search="searchGroup"
                placeholder="Search"
              >
              </search-bar>
            </div>        
          </div>
          <data-table
            :key="refreshTable"
            :apiMode="true"
            :tableOpts="permissionTableColOpts"
            :loadData="loadData"
            @cell-clicked="onCellClicked"
          />
          </div>
        </div>
        <div class="column">
          <div class="has-background-grey-lighter is-border-radius-sm">
          <div class="columns" v-if="!$_.isEmpty(selectedGroup)">
            <div
              class="column is-narrow"
            >
              <button
                @click="onCellClicked({ type: 'cancel' })"
                v-tooltip="'Cancel'"
                class="button p-0 is-outlined is-danger mr-2"
              >
                <i class="icon-close has-text-black-bis"></i>
              </button>
              <button
                @click="onCellClicked({ type: 'save' })"
                v-tooltip="'Save'"
                v-if="!selectedGroup.isLocked && hasPermission"
                class="button is-success has-text-white p-0"
              >
                <i class="icon-checkmark has-text-white"></i>
              </button>
            </div>
            <div class="is-divider-vertical mx-0"></div>
            <div class="column" v-if="!$_.isEmpty(selectedGroup)">
              <button v-if="hasPermission"
                    :disabled="selectedGroup.isLocked ||  $_.isEmpty(selectedGroup?._id)"
                    @click="resetToDefault(selectedGroup)"
                    class="button has-background-black-bis has-text-white has-text-weight-bold"
                  >
                    Reset To Default
                </button>
            </div>
          </div>
          <div class="columns" v-if="!$_.isEmpty(selectedGroup)">
            <div class="column is-6">
              <h3
                class="has-text-black-bis is-size-3 line-height has-text-weight-semibold"
              >
                Name
              </h3>
              <div
                v-if="selectedGroup.isLocked || !hasPermission"
                class="is-size-3 has-text-black-bis is-italic"
              >
                {{ selectedGroup.name }}
              </div>
              <input
                v-else
                class="input generic-input permission-name"
                placeholder="Enter Name"
                v-model.trim="selectedGroup.name"
              />
            </div>

          </div>
          <div
            class="column permission-col p-0"
            v-if="!$_.isEmpty(selectedGroup)"
          >
            <div
              class="permission-table-section has-background-grey-darker"
              v-for="pModule in selectedGroup.permissions"
              :key="pModule.key"
            >
              <div class="column">
                <div class="field">
                  <h3 class="label has-text-white is-size-5 is-capitalized">
                    {{ pModule.key }}
                  </h3>
                  <div class="control">
                    <table
                      class="table permission-table has-background-white is-bordered is-striped is-hoverable is-fullwidth"
                    >
                      <tbody>
                        <template v-for="p in pModule.subsetPermission" :key="p.desc">
                          <tr v-if="!p.hideOption">
                            <td class="is-size-5 columns">
                              <div class="column is-5 perm-desc has-text-black-bis is-capitalized">
                                {{ getUpdatedDesc(p.desc) }}
                              </div>
                              <div class="column">
                                <div class="columns reverse-column">
                                  <div
                                    class="column is-3"
                                    v-for="permissionValue in getValues(p)"
                                    :key="permissionValue.label"
                                    v-tooltip="p.toolTip ? p.toolTip : ''"
                                  >
                                    <o-radio
                                      class="permission-radio"
                                      :key="refreshBtns"
                                      :disabled="p.disabled || !hasPermission"
                                      v-model="p.value"
                                      @update:modelValue="changeDisable(p, pModule)"
                                      :name="p.module + ' ' + p.desc"
                                      :native-value="permissionValue.value"
                                    >
                                      {{ $_.startCase(permissionValue.label) }}
                                    </o-radio>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="box is-flex is-align-items-center is-justify-content-center"
            v-if="!selectedGroup.name && selectedGroup.name !== ''"
          >
            <h3 class="has-text-black-bis is-italic is-size-3 has-text-weight-semibold">
              Edit or create a Permission Group
            </h3>
          </div>
        </div>
        </div>
      </div>
    </div>
    <o-loading
      :full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></o-loading>
    <activity-log
      :id="user.company"
      :company="user.company"
      :isActive="showActivityLog"
      @update:isActive="showActivityLog = false"
    ></activity-log>
  </div>
</template>

<script>
import { onBeforeMount, reactive, ref, toRefs } from "vue";
import Companies from "@/models/Companies";
import DataTable from "@/components/table-fields/DataTable.vue";
import { useStore } from "vuex";
import _ from "lodash";
import { useToast } from "vue-toastification";
import { DialogProgrammatic } from "@/components/Dialog";
import SearchBar from "@/components/SearchBar.vue";
import ActivityLog from "@/components/ActivityLog.vue";
import PermissionMixin from '@/components/mixins/PermissionMixin';

export default {
  name: "permission-groups",
  components: {
    DataTable,
    SearchBar,
    ActivityLog,
  },
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();
    const disableAction = ref(false);
    const { getPermissionValues } = PermissionMixin();

    const permissionTableColOpts = {
      rearrangeCols: false,
      isCheckable: false,
      gutterOpts: {},
      toolBar: {
        buttons: [
          {
            event: "addNew",
            icon: "icon-addnew",
            isLine: true,
            tooltip: "Add New",
          },
        ],
        bulkActions: () => {},
      },
      fields: [
        {
          title: "Permission Group",
          width: "400px",
          name: "field-generic-input",
          id: "name",
          prop: "name",
          defaultVisible: true,
          alwaysVisible: true,
          inputProps: {
            type: "text",
            id: "permission",
          },
        },
        {
          title: "Actions",
          name: "table-field-actions",
          id: "action",
          hideFromChooser: true,
          alwaysVisible: false,
          defaultVisible: true,
          width: "112px",
          permissionModule: "app&projects",
          permissionKey: "company_permissions",
          inputProps: {
            groupButtons(rowData) {
              const buttons = [];
              const obj = {
                icon: "icon-edit",
                event: "edit",
              };
              if (disableAction.value) {
                obj.disabled = true;
              }
              buttons.push(obj);
              if (
                !rowData.isUsed &&
                !rowData.isLocked &&
                !disableAction.value && data.hasPermission
              ) {
                buttons.push({
                  icon: "icon-bin",
                  event: "delete",
                });
              }
              return buttons;
            },
          },
        },
      ],
    };

    const secondaryModule = {
      general: "General",
      "app&projects": "App & Project Setup - Company Settings",
      "projectsTab": "App & Project Setup - Project Settings",
      "app&proMem": "App & Project Setup - User Management",
      'catalog': "App & Project Setup - Catalog",
      // prefabs: "Prefab Planner",
      'projectPlanner': 'Project Planner',
      "production-manager": "Production Manager",
      scm: "Supply Chain Manager",
      shipping: "Shipping Orders",
      "material-manager": "Material Manager",
      // inventory: "Inventory Manager",
      'logistics': 'Logistics Manager',
      "production-order": "Production Orders",
      manufactonSettings: "App & Project Setup - Manufacton Settings", // need to remove
      home: "Home",
    };

    const manufactonSettingsKey = [
      "manufacton_settings",
      "company_templates",
      "company_permissions",
      "company_colors",
      "company_qrs",
      "company_lists",
      "company_security",
      "analytics",
      "custom_fields",
      "measure_units",
    ];

    const data = reactive({
      user: {},
      searchVal: "",
      viewAll: false,
      refreshBtns: 0,
      refreshTable: 0,
      isLoading: false,
      resumeAll: false,
      selectedGroup: {},
      dataLoaded: false,
      hasPermission: true,
      showActivityLog: false,
      permissionGroupCount: [],
      availablePermissions: [],
      orderPermissionEdit: false,
      defaultPermisisonGroups: [],
      permissionTableColOpts,
    });

    onBeforeMount(async () => {
      try {
        data.isLoading = true;
        await store.getters.userPromise;
        data.user = store.state.userData;
        data.company = await Companies.getOne(data.user.company);
        defaultOrderPermissionVal();
        data.permissionGroupCount = await Companies.getPermissionGroupCount();
        await availPermissions();
        data.hasPermission = !(getPermissionValues({
          permissionModule: 'app&projects',
          type: 'alterPermission',
        }))
      } catch (e) {
        console.error("Error: ", e);
      } finally {
        data.isLoading = false;
        data.dataLoaded = true;
      }
    });

    const ordersPermissionSave = async () => {
      data.company.viewAllOrders = data.viewAll;
      data.company.resumeOrdersByAll = data.resumeAll;
      data.company = await Companies.save(data.company);
      data.orderPermissionEdit = false;
    };

    const defaultOrderPermissionVal = () => {
      data.viewAll = data.company.viewAllOrders;
      data.resumeAll = data.company.resumeOrdersByAll;
    };

    const cancelOrederPermissionEdit = () => {
      data.orderPermissionEdit = false;
      defaultOrderPermissionVal();
    };

    const searchGroup = (val) => {
      data.searchVal = val;
      data.refreshTable++;
    };

    const loadData = async () => {
      try {
        let groupData = await Companies.getPermissionGroups();
        groupData.forEach((group) => {
          group.isUsed = false;
          const result = _.find(data.permissionGroupCount, {
            _id: [group._id],
          });
          if (result) group.isUsed = true;
        });
        if (!_.isEmpty(data.searchVal)) {
          groupData = groupData.filter((dt) =>
            dt.name.toLowerCase().includes(data.searchVal.toLowerCase())
          );
        }
        groupData = _.filter(
          groupData,
          (p) => !(p.name === "Project Admin" && p.isLocked === true)
        );
        return { data: groupData || [], total: groupData.length };
      } catch (e) {
        console.error("Error: ", e);
      }
    };

    const availPermissions = async () => {
      const avlbPerms = await Companies.getAvailablePermissions();
      [data.availablePermissions] = await Promise.all([avlbPerms]);
      data.defaultPermisisonGroups = _.cloneDeep(data.availablePermissions);
    };

    const keysToDisable = (pMdule) => {
      const moduleKeys = {
        company_profile: [
          "general_inventory",
          "company_locations",
          "custom_fields",
          "company_templates",
          "company_qrs",
          "company_lists",
          "measure_units",
          // "assembly_parts",
          "vendors",
          "company_colors",
          "analytics",
          "company_settings",
        ],
        manufacton_settings: [
          // "company_security",
          // "company_permissions",
        ],
        owner_location: [
          "data",
          "quantity",
          "transfer_request",
          "production-status",
          "material-status",
          "shipping",
          "move",
          "mobile_login",
        ],
      };
      return moduleKeys[pMdule];
    };

    const disableOptions = (pModule, pKey, key) => {
      const permission = _.find(data.selectedGroup.permissions, {
        module: pModule,
        key: pKey,
      });
      const companyProfilePermVal =
        permission && permission.value ? permission.value : "alter";
      const pkeys = keysToDisable(pKey);
      if (pkeys && pkeys.includes(key) && companyProfilePermVal === "none") {
        return true;
      }
      return false;
    };

    const updateRelatedModules = (
      currentVal,
      pModule = {},
      onlyDisable = false
    ) => {
      const permGroup = _.groupBy(data.availablePermissions, "module");
      if (
        ["production-manager", "production-order", "prefabs"].includes(
          currentVal.module
        )
      ) {
        if (currentVal.key === "data") {
          const psGroup = _.find(
            permGroup.scm,
            (dt) => dt.key === "production-status"
          );
          const prefab = (permGroup.prefabs || []).find(
            (dt) => dt.key === "data"
          );
          const po = (permGroup["production-order"] || []).find(
            (dt) => dt.key === "data"
          );
          const pm = (permGroup["production-manager"] || []).find(
            (dt) => dt.key === "data"
          );
          if (
            prefab.value === "none" &&
            po.value === "none" &&
            pm.value === "none"
          ) {
            psGroup.disabled = currentVal.value === "none";
            if (!onlyDisable) {
              psGroup.toolTip =
                currentVal.value === "none"
                  ? `${_.startCase(currentVal.module)} permission is required`
                  : "";
              psGroup.value = "view";
            }
          } else psGroup.disabled = false;
        }
      }
      if (currentVal.module === "app&projects") {
        for (const dt of pModule.subsetPermission) {
          const disablekeys = keysToDisable(currentVal.key);
          if (disablekeys && disablekeys.includes(dt.key)) {
            dt.disabled = currentVal.value === "none";
          }
        }
      }
      if (
        currentVal.module === "general" &&
        currentVal.key === "owner_location"
      ) {
        const relatedModules = _.pick(permGroup, [
          "material-manager",
          "production-order",
          "production-manager",
          "prefabs",
          "scm",
          "shipping",
          "inventory",
          "general",
        ]);
        // eslint-disable-next-line
        for (const md in relatedModules) {
          relatedModules[md].forEach((perm) => {
            if (keysToDisable(currentVal.key).includes(perm.key)) {
              perm.disabled = currentVal.value === "none";
              if (currentVal.value === "none" && !onlyDisable) {
                perm.value = ["move", "quantity", "mobile_login"].includes(
                  perm.key
                )
                  ? "none"
                  : "view";
                perm.toolTip = "Owner and Location permission is required";
              }
            }
          });
        }
      }
    };

    const setGroupedModules = () => {
      data.availablePermissions = _.cloneDeep(data.defaultPermisisonGroups);
      data.availablePermissions.forEach((p) => {
        if (!data.selectedGroup.permissions) {
          if (
            ["company_profile", "manufacton_settings", "analytics"].includes(
              p.key
            )
          ) {
            p.value = "view";
          } else p.value = "alter";
        } else {
          const result = _.find(data.selectedGroup.permissions, {
            module: p.module,
            key: p.key,
          });
          if (result) p.value = result.value;
          else {
            p.value = "view";
          }
        }
        const companyProfileKeys = keysToDisable("company_profile");
        const manufactonSettingsKeys = keysToDisable("manufacton_settings");
        if (['company_security', 'general_inventory', 'manufacton_settings', 'measure_units'].includes(p.key)) p.hideOption = true
        if ((p.module === 'production-manager' && p.key === 'checklist') ||
          (p.module === 'scm' && p.key === 'checklist') || (p.module === 'scm' && p.key === 'shipping')) {
          p.hideOption = true
        }
        if (data.selectedGroup.isLocked || ["owner_location"].includes(p.key)) {
          p.disabled = true;
        } else if (companyProfileKeys && companyProfileKeys.includes(p.key)) {
          p.disabled = disableOptions("app&projects", "company_profile", p.key);
        } else if (
          manufactonSettingsKeys &&
          manufactonSettingsKeys.includes(p.key)
        ) {
          p.disabled = disableOptions(
            "app&projects",
            "manufacton_settings",
            p.key
          );
        } else if (!p.disabled) {
          p.disabled = false;
        }
        if (["material-manager", "inventory"].includes(p.module)) {
          updateRelatedModules(p, null, true);
        }
      });
      _.filter(data.availablePermissions, (indvPermission) => {
        if (["members", "company_permissions"].includes(indvPermission.key)) {
          indvPermission.secondaryModule = secondaryModule["app&proMem"];
        } else if (indvPermission.key === 'projects') {
          indvPermission.secondaryModule = secondaryModule.projectsTab
        } else if (indvPermission.key === 'assembly_parts'){
          indvPermission.secondaryModule = secondaryModule.catalog;
        } else if (['prefabs', 'production-order'].includes(indvPermission.module)) {
          indvPermission.secondaryModule = secondaryModule.projectPlanner
        } else if (['inventory', 'shipping'].includes(indvPermission.module)) {
          indvPermission.secondaryModule = secondaryModule.logistics
        } else {
          indvPermission.secondaryModule =
            secondaryModule[indvPermission.module];
        }
        // else if (manufactonSettingsKey.includes(indvPermission.key)) {
        //   indvPermission.secondaryModule = secondaryModule.manufactonSettings;
        // } 

      });
      const pModules = [];
      if (
        data.selectedGroup.isLocked &&
        data.selectedGroup.name === "Project Admin"
      ) {
        const projectdata = _.find(data.availablePermissions, {
          module: "app&projects",
          key: "projects",
        });
        pModules.push({
          key: projectdata.secondaryModule,
          subsetPermission: [projectdata],
        });
      } else {
        const groupedModule = _.groupBy(
          data.availablePermissions,
          "secondaryModule"
        );
        for (const pModule in groupedModule) {
          if (pModule) {
            let subModules = groupedModule[pModule];
            if (
              data.selectedGroup.name !== "View Only Member" &&
              pModule === "General"
            ) {
              subModules = groupedModule[pModule].filter(
                (dt) => dt.key !== "owner_location"
              );
            }
            pModules.push({
              key: pModule,
              subsetPermission: subModules,
            });
          }
        }
      }
      data.selectedGroup.permissions = pModules;
    };

    const setEditGroup = (rowData, val) => {
      if (val) {
        data.selectedGroup = _.cloneDeep(rowData);
        setGroupedModules();
      } else {
        data.selectedGroup = {};
      }
      disableAction.value = val;
    };

    const newPermissionGroup = () => {
      data.selectedGroup = {
        name: "",
        newRow: true,
      };
      setGroupedModules();
      disableAction.value = true;
    };

    const updateOrCreateGroup = _.debounce(
      async () => {
        const isGroupExist = _.find(
          store.state.availablePermissionGroups,
          (group) => {
            const groupName = data.selectedGroup.name.trim();
            return group.name.toLowerCase() === groupName.toLowerCase();
          }
        );
        const groupData = {};
        if (data.selectedGroup.isLocked) {
          toast.error("Cannot save the locked permission group");
          return false;
        }
        if (data.selectedGroup.name.trim().length < 3) {
          toast.warning(
            "Permission group name must contain at least 3 characters"
          );
        } else if (isGroupExist && data.selectedGroup.newRow) {
          toast.warning("Permission group name already exists");
        } else {
          groupData.name = data.selectedGroup.name;
          groupData.user = { company: data.user.company };
          groupData.id = data.selectedGroup.newRow
            ? "new"
            : data.selectedGroup._id;
          groupData.permissions = [];
          data.selectedGroup.permissions.forEach((p) => {
            p.subsetPermission.forEach((permission) => {
              groupData.permissions.push({
                module: permission.module,
                key: permission.key,
                value: permission.value,
              });
            });
          });
          try {
            data.isLoading = true;
            const res = await Companies.createUpdatePermissionGroups(groupData);
            store.dispatch("getUserData");
            await store.state.userData;
            await store.state.availablePermissionGroups;
            disableAction.value = false;
            data.refreshTable++;
            data.selectedGroup = {};
            if (res.status === 200) {
              toast.success("Group added/updated successfully");
            }
          } catch (e) {
            toast.error("Error while adding/updating group");
            console.error(e);
          } finally {
            data.isLoading = false;
          }
        }
      },
      500,
      { leading: true, trailing: false }
    );

    const onCellClicked = async (opts) => {
      if (["edit", "add"].includes(opts.type) && disableAction.value) {
        toast.error("Already in edit mode");
        return;
      }
      if (opts.type === "edit") {
        setEditGroup(opts.data, true);
      } else if (opts.type === "cancel") {
        setEditGroup({}, false);
      } else if (opts.type === "add") {
        newPermissionGroup();
      } else if (opts.type === "save") {
        await updateOrCreateGroup();
      } else if (opts.type === "delete") {
        DialogProgrammatic.confirm({
          title: "Delete Permission Group?",
          message: "Are you sure you want to delete this permission group?",
          okButton: "OK",
          cancelButton: "Cancel",
          onConfirm: async () => {
            try {
              data.isLoading = true;
              const res = await Companies.deletePermissionGroup(opts.data._id);
              data.refreshTable++;
              toast.success(`Permission group ${_.lowerCase(res.data.msg)}`);
            } catch (e) {
              console.log(e);
              toast.error("Error deleting permission group");
            } finally {
              data.isLoading = false;
            }
          },
        });
      }
    };

    const getValues = (permission) => {
      const options = [];
      permission.values.forEach((val) => {
        const modulesToExclude = [
          "app&projects",
          "home",
          "company-profile",
          "manufacton-settings",
        ];
        if (
          ["receive", "move", "quantity", "auto_add_users"].includes(
            permission.key
          )
        ) {
          options.push({
            label: val === "none" ? "no" : "yes",
            value: val,
          });
        } else if (["owner_location"].includes(permission.key)) {
          options.push({
            label: val === "none" ? "Hide" : "Show",
            value: val,
          });
        } else if (["mobile_login", "qr_scan"].includes(permission.key)) {
          options.push({
            label: val === "none" ? "Disallow" : "Allow",
            value: val,
          });
        } else {
          let opt = val;
          if (val === "viewPartial") opt = "Limited View";
          if (val === "alterPartial") opt = "Limited Edit";
          if (val === "alter") opt = "edit";
          if (
            val === "view" &&
            !(
              modulesToExclude.includes(permission.module) ||
              ["checklist", "calnder_model"].includes(permission.key)
            )
          ) {
            opt = "Full View";
          }
          if (val === "none") opt = "hide";
          options.push({
            label: opt,
            value: val,
          });
        }
      });
      return options;
    };

    const showDialog = (currentVal, pModule) => {
      const msgMap = {
        manufacton_settings:
          "Permission will be changed for Tabs under Manufacton Settings",
        company_profile:
          "Permission will be changed for Tabs under Company Settings",
        general: "All List view and Order movement permission will be changed",
        "production-manager": "Production Status permission will be changed",
        "production-order": "Production Status permission will be changed",
        prefabs: "Production Status permission will be changed",
      };
      const dailogMsg =
        currentVal.module === "app&projects"
          ? msgMap[currentVal.key]
          : msgMap[currentVal.module];
      DialogProgrammatic.confirm({
        title: "Are you sure?",
        message: dailogMsg,
        okButton: "Ok",
        additionalButton: "Cancel",
        onConfirm: async () => {
          try {
            updateRelatedModules(currentVal, pModule);
            data.refreshBtns += 1;
          } catch (error) {
            console.error("Error", error);
          }
        },
        additionalMethod: () => {
          if (currentVal.module === "app&projects") currentVal.value = "view";
          else currentVal.value = "alter";
          data.refreshBtns += 1;
        },
      });
    };

    const changeDisable = (currentVal, pModule) => {
      if (
        ["general"].includes(currentVal.module) &&
        ["data", "move", "owner_location"].includes(currentVal.key) &&
        currentVal.value !== "alter"
      ) {
        showDialog(currentVal, pModule);
      } else if (
        currentVal.module === "app&projects" &&
        ["company_profile", "manufacton_settings"].includes(currentVal.key) &&
        currentVal.value !== "view"
      ) {
        showDialog(currentVal, pModule);
      } else if (
        ["production-manager", "production-order", "prefabs"].includes(
          currentVal.module
        ) &&
        currentVal.key === "data" &&
        currentVal.value === "none"
      ) {
        showDialog(currentVal, pModule);
      } else {
        updateRelatedModules(currentVal, pModule);
        data.refreshBtns += 1;
      }
    };

    const resetToDefault = async (selectedGroup) => {
      try {
        data.isLoading = true;
        const updatedGroup = await Companies.resetPermissionGroup(
          _.get(selectedGroup, "_id", "")
        );
        await store.dispatch("getUserData");
        await store.state.userData;
        await store.state.availablePermissionGroups;
        data.refreshTable++;
        data.selectedGroup = {};
        disableAction.value = false;
        toast.success(`${updatedGroup.name} Group Reset Successfully`);
      } catch (e) {
        console.log("Error", e);
        toast.error("Error resetting group");
      } finally {
        data.isLoading = false;
      }
    };

    const getUpdatedDesc = (desc) => {
      const descMap = {
        'Company Profile': 'All Company Settings',
        'Individual project settings': 'Project Settings',
        'Company Members list': 'Users',
        'Edit Permissions': 'Permissions',
        'Company account settings': 'Account',
        'Order Templates': 'Templates',
        'Third Party Plugins': 'Integrations',
        'Assemblies / Parts catalog': 'Catalog',
        'Prefab Packages': 'Planning',
        'Allow Prefab Package movement': 'Allow production order creation from Planning',
        'Production Orders (in Prefab Planner)': 'Coordination',
        'Inventory Entry data': 'Inventory',
        'Allow Shipping Order receive': 'Receive shipping orders',
        'Production Status tab': 'Production Status',
        'Material Status tab': 'Material Status'
      }
      return descMap[desc] || desc
    }

    return {
      ...toRefs(data),
      ordersPermissionSave,
      cancelOrederPermissionEdit,
      permissionTableColOpts,
      loadData,
      onCellClicked,
      getValues,
      changeDisable,
      disableAction,
      searchGroup,
      resetToDefault,
      getUpdatedDesc
    };
  },
};
</script>

<style scoped>

.permission-col table.vuetable td {
  overflow: visible !important;
}

.permission-col .permission-table-section {
  margin-bottom: 16px;
}


/* [type=radio]:checked {
	left: unset !important
} */

::v-deep(.o-radio [type="radio"]:checked),
::v-deep(.o-radio [type="radio"]:not(:checked)) {
  left: unset !important;
  background-color: #fff !important;
}

::v-deep(.o-radio .o-radio__label) {
  margin-left: 16px;
}

.permission-name,
::v-deep(.searchbar input) {
  border: 1px solid black !important;
}

::v-deep(.permission-radio .o-radio__check) {
  border: 1px solid #000 !important;
  background-image: url() !important;
}

::v-deep(.permission-radio .o-radio__check--checked) {
  border-color: 1px solid #000 !important;
  background-color: #fff !important;
}

::v-deep(.permission-radio .o-radio__check--checked::after) {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #000 !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

::v-deep(.permission-radio .o-radio__label) {
  color: #333333;
}

.permission-table-section .table.is-bordered td {
  border: none !important;
}
::v-deep(.searchbar .input) {
  padding-left: 5px !important;
}
</style>>